module.exports = require('./dist/echarts-amap.min.js')



//////////////////
// WEBPACK FOOTER
// ./~/echarts-amap/index.js
// module id = I8dn
// module chunks = 29